// extracted by mini-css-extract-plugin
export default {"nav":"index_nav_3pUKU","navItem":"index_navItem_eeBuC","mainTitle":"index_mainTitle_fLOsu","sub":"index_sub_J7unP","subTitle":"index_subTitle_8Pbi1"};